export default __webpack_public_path__ + "static/media/Group911.8d892bc8.svg";